export const COLLECTIONS_ALL = 'all'
export const COLLECTIONS_SHARED = 'shared'
export const COLLECTIONS_UNCATEGORIZED = 'uncategorized'

export const BUILT_IN_COLLECTIONS_LABELS = {
  [COLLECTIONS_ALL]: 'All',
  [COLLECTIONS_SHARED]: 'Shared',
  [COLLECTIONS_UNCATEGORIZED]: 'Uncategorized'
}

export const BUILT_IN_COLLECTIONS = [COLLECTIONS_ALL, COLLECTIONS_SHARED, COLLECTIONS_UNCATEGORIZED]
